import { LitElement, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

import { ifDefined } from 'lit/directives/if-defined.js';
import { classMap } from 'lit/directives/class-map.js';

import copyrightIcon from '@amityeko/design-system/dist/assets/icons/copyright';
import awardIcon from '@amityeko/design-system/dist/assets/icons/award';

import '@amityeko/design-system/dist/elements/icon';
import '@amityeko/design-system/dist/elements/badge';
import '@amityeko/design-system/dist/elements/typography/tg-body-two';
import '@amityeko/design-system/dist/elements/icon-badge';
import '@amityeko/design-system/dist/elements/skeleton';

import styles from './styles';

/** */
@customElement('rnr-client-badge-card')
export default class RnRClientBadgeCard extends LitElement {
  static styles = styles;

  @property({ type: Boolean })
  selected: boolean = false;

  @property()
  imageSrc?: string;

  @property()
  cardTitle?: string;

  @property({ type: Number })
  points?: number;

  @property({ type: Boolean })
  icon: boolean = false;

  @property({ type: Boolean })
  isLoading?: boolean;

  @state()
  isImageBroken: boolean = false;

  private _renderImage() {
    //show skeleton for image loading state
    if (this.isLoading) {
      return html`<amityeko-skeleton
        .width=${'80px'}
        .height=${'80px'}
        .borderRadius=${'50%'}
      ></amityeko-skeleton>`;
    }

    //show badge icon for image broken state
    if (this.isImageBroken) {
      return html`
        <amityeko-icon-badge .containerSize=${'80px'}>
          <amityeko-icon .iconSize=${'40px'}>${awardIcon}</amityeko-icon>
        </amityeko-icon-badge>
      `;
    }

    //show image for existing image state
    if (this.imageSrc) {
      return html`<img
        src=${ifDefined(this.imageSrc)}
        @error=${() => (this.isImageBroken = true)}
      />`;
    }

    //show badge icon for default state
    return html`
      <amityeko-icon-badge .containerSize=${'80px'}>
        <amityeko-icon .iconSize=${'40px'}>${awardIcon}</amityeko-icon>
      </amityeko-icon-badge>
    `;
  }

  protected render() {
    const badgeVariant = this.selected ? 'primary' : 'default';

    return html`
      <div class="card ${classMap({ 'card--selected': this.selected })}">
        ${this._renderImage()}
        <amityeko-tg-body-two>${this.cardTitle}</amityeko-tg-body-two>
        <amityeko-badge .variant=${badgeVariant}>
          ${this.icon ? html`<amityeko-icon slot="icon">${copyrightIcon}</amityeko-icon>` : null}
          ${this.points}
        </amityeko-badge>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'rnr-client-badge-card': RnRClientBadgeCard;
  }
}
